import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="font-display text-4xl font-semibold text-white">RENFORTEO</h1>
          <p className="mt-1 text-xs uppercase tracking-[0.35em] text-[hsl(39,63%,62%)]">Prospection</p>
        </div>
        <form onSubmit={submit} className="rounded-xl bg-card p-8 shadow-2xl">
          <h2 className="font-display text-xl font-semibold">Connexion</h2>
          <p className="mt-1 text-sm text-muted-foreground">Accédez à votre espace de prospection</p>
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password-input" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full" data-testid="login-submit-button">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </div>
          <div className="mt-5 text-sm">
            <Link to="/forgot-password" className="text-muted-foreground hover:text-foreground" data-testid="forgot-password-link">Mot de passe oublié ?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
